export const atlassianStandsWithUkraineMessage = {
  header: 'Atlassian stands with Ukraine',
  body: 'Following the Russian invasion of Ukraine, we are pausing the sale of new software in Russia and Belarus. Partners from these regions will not be able to create new apps.',
  learnMoreLink: 'https://www.atlassian.com/blog/announcements/atlassian-stands-with-ukraine'
};